/**
 * Created by andreaskarantzas on 20.04.21.
 */
import { makeAutoObservable } from 'mobx';

export type ExerciseSetPause = {
  startDateTime: Date;
  endDateTime?: Date;
  readonly isPauseRunning: boolean;
  readonly pauseDuration: number;
  stop(): void;
};

export function createExerciseSetPause(source?: Partial<ExerciseSetPause>): ExerciseSetPause {
  return makeAutoObservable({
    startDateTime: source?.startDateTime ? new Date(source.startDateTime as any) : new Date(),
    endDateTime: source?.endDateTime ? new Date(source.endDateTime as any) : undefined,

    stop() {
      if (!this.endDateTime) {
        this.endDateTime = new Date();
      }
    },

    get isPauseRunning(): boolean {
      return !this.endDateTime;
    },

    get pauseDuration(): number {
      return (this.endDateTime ?? new Date()).valueOf() - this.startDateTime.valueOf();
    },
  });
}
